import React from 'react';
import { Col, Layout, Row, Typography } from 'antd';
import { Input } from 'components';
import './style.scss';
import { useLang } from '../PlayerRegistration';

export const Step8 = () => {
  const { t } = useLang();

  return (
    <Layout className="player-registration__step-8">
      <Row className="step-header">
        <Col span={24}>
          <Typography.Title level={4}>{t('subtitle_step_8')}</Typography.Title>
        </Col>
        <Col span={24}>
          <Typography.Text>{t('description_step_8')}</Typography.Text>
        </Col>
      </Row>
      <Row gutter={8}>
        <Col span={24} md={{ span: 12 }}>
          <Input name="instagram" label="Instagram" />
        </Col>
        <Col span={24} md={{ span: 12 }}>
          <Input name="facebook" label="Facebook" />
        </Col>
        <Col span={24} md={{ span: 12 }}>
          <Input name="twitter" label="X (Twitter)" />
        </Col>
      </Row>
    </Layout>
  );
};
